export default __webpack_public_path__ + "static/media/62.05378b17.jpeg";